import LessonAccordionContainer from './container'
export default LessonAccordionContainer
